import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'momentAgo'
})
export class MomentAgoPipe implements PipeTransform {

  transform(value: any): any {
    //return value ? moment(value).lang("th").fromNow() : '';
    if(value != null && value != undefined && value != ''){ 
      if(moment().subtract(7,'d') < moment(value)){ 
        return value ? moment(value).locale("th").fromNow() : '';
      }
      else {
        return value ? moment(value).locale("th").format('DD/MM/YYYY') : '';
      }
    }
  }

}
